const toggleBodyClassOnScroll = ( className ) => {
	if ( ! className ) {
		throw new Error( 'A class name must be provided.' );
	}
	const btnBackTop = document.querySelector( '[rel="back-top"]' );
	btnBackTop.addEventListener( 'click', () => {
		window.scrollTo( {
			top: 0,
			behavior: 'smooth',
		} );
	} );
	window.addEventListener( 'scroll', () => {
		const scrollTop = window.scrollY || document.documentElement.scrollTop;

		if ( scrollTop > 100 ) {
			btnBackTop.style.opacity = 1;
		} else {
			btnBackTop.style.opacity = 0;
		}

		// eslint-disable-next-line no-unused-expressions
		scrollTop > 0
			? document.body.classList.add( className )
			: document.body.classList.remove( className );
	} );
};

export default toggleBodyClassOnScroll;
